/* Decantified — shared front-end helpers (cart, wishlist, recently viewed, mini cards) */
(function () {
  if (window.DC) return;
  var DC = {};
  var cache = {};

  DC.money = function (cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  };

  DC.clean = function (title) {
    return String(title || '')
      .replace(/\s*[–-]\s*(1\s?ml\s*)?sample\s*decants?.*$/i, '')
      .replace(/\s*[–-]\s*decant.*$/i, '')
      .trim();
  };

  DC.house = function (title) {
    var t = DC.clean(title);
    var m = t.match(/\s(?:by|By|BY)\s(.+)$/);
    return m ? m[1].trim() : '';
  };

  DC.name = function (title) {
    var t = DC.clean(title);
    return t.replace(/\s(?:by|By|BY)\s.+$/, '').trim();
  };

  DC.insp = function (vendor) {
    var v = String(vendor || '').trim();
    var l = v.toLowerCase();
    if (!v || l.indexOf('original composition') > -1 || l.indexOf('inspiration: original') > -1 || l === 'decantified') return { kind: 'original', name: '' };
    var kind = l.indexOf('compared') > -1 ? 'compared' : 'inspired';
    var name = v.indexOf(':') > -1 ? v.split(':').slice(1).join(':') : v.replace(/^inspired by the legacy of/i, '').replace(/^often compared to/i, '').replace(/^inspired by/i, '').replace(/^inspiration:?/i, '');
    name = name.replace(/^\s*\/\s*/, '').trim();
    if (!name) return { kind: 'original', name: '' };
    return { kind: kind, name: name };
  };

  /* Inspired-by source: the hidden 'insp:' tag (mirror of the custom.inspired_by metafield),
     else the vendor only if it still reads like an inspired-by label (vendor now holds the real house). */
  DC.inspSrc = function (p) {
    if (!p) return '';
    var t = p.tags || [];
    if (typeof t === 'string') t = t.split(',');
    for (var i = 0; i < t.length; i++) {
      var s = String(t[i]).trim();
      if (s.toLowerCase().indexOf('insp:') === 0) return s.slice(5).trim();
    }
    var v = String(p.vendor || '');
    return /inspir|compar|original|^decantified$/i.test(v) ? v : '';
  };

  DC.inspLabel = function (vendor) {
    var i = DC.insp(vendor);
    if (i.kind === 'original') return '';
    return (i.kind === 'compared' ? 'Often compared to ' : 'Inspired by ') + i.name;
  };

  DC.sizeVariant = function (product, size) {
    var s = String(size).toLowerCase().replace(/\s+/g, '');
    var vs = product.variants || [];
    for (var i = 0; i < vs.length; i++) {
      var t = String(vs[i].option1 || vs[i].title || '').toLowerCase().replace(/\s+/g, '');
      if (t === s || (s === 'fullbottle' && t.indexOf('fullbottle') === 0)) return vs[i];
    }
    return null;
  };

  DC.product = function (handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  };

  DC.collection = function (handle, limit) {
    var key = 'col:' + handle + ':' + (limit || 24);
    if (cache[key]) return cache[key];
    cache[key] = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + (limit || 24), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).map(DC.normalise); })
      .catch(function () { return []; });
    return cache[key];
  };

  /* products.json and product.js use slightly different shapes; normalise to the .js shape */
  DC.normalise = function (p) {
    if (!p) return p;
    if (typeof p.price === 'number' && p.variants && p.variants.length && typeof p.variants[0].price === 'number') return p;
    var out = {
      id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, tags: p.tags, url: '/products/' + p.handle,
      featured_image: p.images && p.images[0] ? p.images[0].src : (p.featured_image || null),
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id, title: v.title, option1: v.option1, available: v.available,
          price: Math.round(parseFloat(v.price) * 100),
          compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null
        };
      })
    };
    var av = out.variants.filter(function (v) { return v.available; });
    out.available = av.length > 0;
    out.price = av.length ? Math.min.apply(null, av.map(function (v) { return v.price; })) : (out.variants[0] ? out.variants[0].price : 0);
    return out;
  };

  DC.img = function (src, w) {
    if (!src) return '';
    return src.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_' + (w || 400) + 'x$1$2');
  };

  DC.toast = function (msg) {
    var el = document.querySelector('.dc-toast');
    if (!el) { el = document.createElement('div'); el.className = 'dc-toast'; document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  };

  /* ---- Cart ---- */
  DC.addToCart = function (items, opts) {
    opts = opts || {};
    var body = { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status >= 400) { DC.toast(res.description || res.message || 'Could not add to cart'); throw res; }
      DC.refreshCart(res, opts.open !== false);
      if (opts.toast !== false) DC.toast(opts.toastText || (items.length > 1 ? items.length + ' decants added to your cart' : 'Added to your cart'));
      try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dc', cartData: res }); } catch (e) {}
      return res;
    });
  };

  DC.refreshCart = function (res, open) {
    var drawer = document.querySelector('cart-drawer');
    if (!open && res && res.sections) {
      try {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections['cart-icon-bubble']) {
          var bd = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          var bs = bd.querySelector('.shopify-section') || bd.body;
          bubble.innerHTML = bs.innerHTML;
        }
        if (drawer && res.sections['cart-drawer']) {
          var dd = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          var nd = dd.querySelector('#CartDrawer'), od = drawer.querySelector('#CartDrawer');
          if (nd && od) od.innerHTML = nd.innerHTML;
          drawer.classList.remove('is-empty');
        }
        return;
      } catch (e) {}
    }
    if (drawer && res && res.sections && typeof drawer.renderContents === 'function') {
      try { drawer.renderContents(res); if (!open) drawer.close && drawer.close(); return; } catch (e) {}
    }
    if (res && res.sections) {
      var tmp = document.createElement('div');
      if (res.sections['cart-drawer']) {
        tmp.innerHTML = res.sections['cart-drawer'];
        var fresh = tmp.querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      if (res.sections['cart-icon-bubble']) {
        tmp.innerHTML = res.sections['cart-icon-bubble'];
        var b = document.getElementById('cart-icon-bubble');
        if (b) b.innerHTML = tmp.innerHTML;
      }
      if (open && drawer && drawer.open) drawer.open();
    }
  };

  /* ---- Wishlist ---- */
  function readLS(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  function writeLS(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  DC.wish = {
    list: function () { return readLS('dc_wish'); },
    has: function (h) { return DC.wish.list().indexOf(h) > -1; },
    toggle: function (h) {
      var l = DC.wish.list(); var i = l.indexOf(h);
      if (i > -1) l.splice(i, 1); else l.unshift(h);
      writeLS('dc_wish', l.slice(0, 100));
      DC.syncWish();
      return i === -1;
    }
  };
  DC.syncWish = function () {
    var l = DC.wish.list();
    document.querySelectorAll('[data-dc-wish]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-dc-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = b.querySelector('[data-dc-wish-label]');
      if (lab) lab.textContent = on ? 'Saved' : 'Save';
    });
    document.querySelectorAll('[data-dc-wish-count]').forEach(function (c) {
      c.textContent = l.length ? l.length : '';
      c.classList.toggle('is-on', l.length > 0);
    });
  };

  /* ---- Recently viewed ---- */
  DC.rv = {
    list: function () { return readLS('dc_rv'); },
    push: function (h) {
      if (!h) return;
      var l = DC.rv.list().filter(function (x) { return x !== h; });
      l.unshift(h);
      writeLS('dc_rv', l.slice(0, 16));
    }
  };

  /* ---- Mini product cards ---- */
  DC.cardHTML = function (p, opts) {
    opts = opts || {};
    var v1 = DC.sizeVariant(p, '1ml');
    var v5 = DC.sizeVariant(p, '5ml');
    var v10 = DC.sizeVariant(p, '10ml');
    var buy = v1 && v1.available ? v1 : (p.variants || []).filter(function (v) { return v.available; })[0];
    var insp = DC.inspLabel(DC.inspSrc(p));
    var name = DC.name(p.title);
    var house = DC.house(p.title);
    var sizes = [];
    if (v1 && v1.available) sizes.push('1ml ' + DC.money(v1.price));
    if (v5 && v5.available) sizes.push('5ml ' + DC.money(v5.price));
    if (v10 && v10.available) sizes.push('10ml ' + DC.money(v10.price));
    var wished = DC.wish.has(p.handle);
    var html = '<div class="dc-pc" data-handle="' + p.handle + '">';
    html += '<button type="button" class="dc-wish' + (wished ? ' is-on' : '') + '" data-dc-wish="' + p.handle + '" aria-label="Save to wishlist" aria-pressed="' + wished + '">' + DC.heart + '</button>';
    html += '<a class="dc-pc__img" href="' + p.url + '">' + (p.featured_image ? '<img loading="lazy" src="' + DC.img(p.featured_image, 400) + '" alt="' + name.replace(/"/g, '&quot;') + '">' : '') + '</a>';
    html += '<div class="dc-pc__body">';
    html += '<a class="dc-pc__name" href="' + p.url + '">' + name + '</a>';
    if (house) html += '<div class="dc-pc__meta">' + house + '</div>';
    if (insp) html += '<div class="dc-pc__insp">' + insp + '</div>';
    if (sizes.length) html += '<div class="dc-pc__meta">' + sizes.join(' · ') + '</div>';
    html += '<div class="dc-pc__price">' + (buy ? 'From ' + DC.money(p.price || buy.price) : 'Sold out') + '</div>';
    if (opts.pick) {
      html += '<button type="button" class="dc-btn dc-btn--ghost dc-pc__add" data-dc-pick="' + p.handle + '"' + (buy ? '' : ' disabled') + '>' + (opts.pickLabel || 'Add to my set') + '</button>';
    } else if (buy) {
      html += '<button type="button" class="dc-btn dc-pc__add" data-dc-add=\'' + JSON.stringify([{ id: buy.id, quantity: 1 }]) + '\'>+ Add ' + (v1 && v1.available ? '1ml' : (buy.option1 || '')) + ' · ' + DC.money(buy.price) + '</button>';
    }
    html += '</div></div>';
    return html;
  };
  DC.heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C1 8.3 3 5 6.4 5c2 0 3.3 1.1 4.1 2.3L12 9l1.5-1.7C14.3 6.1 15.6 5 17.6 5 21 5 23 8.3 21.6 11.8 19.5 16.4 12 21 12 21z"/></svg>';

  DC.renderCards = function (container, products, opts) {
    if (!container) return;
    container.innerHTML = products.map(function (p) { return DC.cardHTML(p, opts); }).join('');
    DC.syncWish();
    container.dispatchEvent(new CustomEvent('dc:rendered', { bubbles: true }));
  };

  /* ---- Delegated clicks ---- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-dc-wish]');
    if (w) {
      e.preventDefault();
      var on = DC.wish.toggle(w.getAttribute('data-dc-wish'));
      DC.toast(on ? 'Saved to your wishlist' : 'Removed from your wishlist');
      return;
    }
    var a = e.target.closest('[data-dc-add]');
    if (a) {
      e.preventDefault();
      var items;
      try { items = JSON.parse(a.getAttribute('data-dc-add')); } catch (err) { return; }
      a.classList.add('is-busy');
      DC.addToCart(items, { toastText: a.getAttribute('data-dc-toast') || undefined, open: a.getAttribute('data-dc-open') !== 'false' }).catch(function () {}).then(function () { a.classList.remove('is-busy'); });
    }
  });

  /* ---- Horizontal chip rows: arrows, fades and mouse-wheel scrolling ---- */
  DC.hscroll = function (el) {
    if (!el || el.getAttribute('data-dc-hs')) return;
    el.setAttribute('data-dc-hs', '1');
    var wrap = document.createElement('div');
    wrap.className = 'dc-hs';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    var bg = '#fff', n = wrap.parentElement;
    while (n && n !== document.documentElement) {
      var c = getComputedStyle(n).backgroundColor;
      if (c && c !== 'transparent' && c !== 'rgba(0, 0, 0, 0)') { bg = c; break; }
      n = n.parentElement;
    }
    wrap.style.setProperty('--dc-hs-bg', bg);
    function mk(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dc-hs__btn dc-hs__btn--' + dir; b.setAttribute('aria-label', label); b.innerHTML = glyph;
      b.addEventListener('click', function () { el.scrollBy({ left: (dir === 'next' ? 1 : -1) * Math.max(160, el.clientWidth * 0.7), behavior: 'smooth' }); });
      wrap.appendChild(b);
    }
    mk('prev', 'Scroll left', '&#8249;');
    mk('next', 'Scroll right', '&#8250;');
    function upd() {
      var max = el.scrollWidth - el.clientWidth;
      wrap.classList.toggle('can-prev', el.scrollLeft > 4);
      wrap.classList.toggle('can-next', el.scrollLeft < max - 4);
    }
    el.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    el.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX) || el.scrollWidth <= el.clientWidth) return;
      var before = el.scrollLeft; el.scrollLeft += e.deltaY;
      if (el.scrollLeft !== before) e.preventDefault();
    }, { passive: false });
    var act = el.querySelector('.is-active');
    if (act && act.offsetLeft > el.clientWidth - 40) el.scrollLeft = act.offsetLeft - 40;
    upd(); setTimeout(upd, 300);
  };
  DC.initHscroll = function (root) {
    (root || document).querySelectorAll('.dc-ns__scroll, .dc-cn__row, .dc-sbx__tabs, [data-dc-hscroll]').forEach(DC.hscroll);
  };
  document.addEventListener('shopify:section:load', function (e) { DC.initHscroll(e.target); });

  document.addEventListener('DOMContentLoaded', function () {
    DC.initHscroll();
    DC.syncWish();
    if (window.DC_PRODUCT_HANDLE) DC.rv.push(window.DC_PRODUCT_HANDLE);
    var mo = new MutationObserver(function () { clearTimeout(DC._wt); DC._wt = setTimeout(DC.syncWish, 120); });
    mo.observe(document.body, { childList: true, subtree: true });
  });

  window.DC = DC;
})();
